import { render, staticRenderFns } from "./ShopWealhRecordDialog.vue?vue&type=template&id=19f66617&scoped=true&"
import script from "./ShopWealhRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ShopWealhRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShopWealhRecordDialog.vue?vue&type=style&index=0&id=19f66617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f66617",
  null
  
)

export default component.exports